import api from "./apis/api";
import {
  dehydrateParticipant,
  dehydrateVideoCallToken,
  hydrateVideoCallToken,
  hydrateMeasurementJSON,
  hydrateDeleteFloorPlan,
} from "./transformers/";
class VideoCallService {
  getVideoCallToken(requestData) {

    return api.videoCall
      .getVideoCallToken(dehydrateVideoCallToken(requestData))
      .then((res) => hydrateVideoCallToken(res.data));
  
  
    }

  inviteParticipant(callUUID, requestData) {
    return api.videoCall.inviteParticipant(
      callUUID,
      dehydrateParticipant(requestData)
    );
  }

  listParticipant(callUUID) {
    return api.videoCall.listParticipant(callUUID);
  }

  callEnd(callUUID) {
    return api.videoCall.callEnd(callUUID);
  }

  getMeasurementJSON(jobOrderId){

    return api.videoCall
      .getMeasurementJSON(jobOrderId)
      .then((res) => hydrateMeasurementJSON(res.data));
  


  }

  deleteFloorPlan(requestData){

    return api.videoCall
      .deleteFloorPlan(requestData)
      .then((res) => hydrateDeleteFloorPlan(res.data));
  
  }


}

export default new VideoCallService();
